<body>
  <mat-tab-group (selectedTabChange)="onTabClick($event)">
          <mat-tab label="Tous les utilisateurs" *ngIf="showdallusers && users">
            <ng-template mat-tab-label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">Tous les utilisateurs</div>
                <span (click)="click2()" class="ms-2"><i class="bi bi-x-circle-fill"></i></span>
              </div>
            </ng-template>
            <div class="container-fluid">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <button (click)="exportusersAsXLSX(getclients(),'Clients Actifs')" class="btn btn-black"><i class="fa fa-file-excel-o"></i></button>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="allusers" (click)="selectallusers()">
                  <label class="form-check-label" for="allusers">Sélectionner tout</label>
                </div>
                <button (click)="deletemultiusers()" class="btn btn-danger">Supprimer utilisateurs</button>
              </div>
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>sélectionner</th>
                      <th scope="col">Email <i class="fa fa-sort" aria-hidden="true" [appSort]="users" data-order="desc" data-name="email"></i></th>
                      <th scope="col">Prenom <i class="fa fa-sort" aria-hidden="true" [appSort]="users" data-order="desc" data-name="firstname"></i></th>
                      <th scope="col">Nom <i class="fa fa-sort" aria-hidden="true" [appSort]="users" data-order="desc" data-name="lastname"></i></th>
                      <th scope="col">Type <i class="fa fa-sort" aria-hidden="true" [appSort]="users" data-order="desc" data-name="usertype"></i></th>
                      <th scope="col">Id</th>
                      <th scope="col">Raison Sociale</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let user of getallusers(); let i = index">
                      <td><input class="form-check-input" type="checkbox" id="{{ 'user' + i }}" /></td>
                      <td>{{user.email}}</td>
                      <td>{{user.firstname}}</td>
                      <td>{{user.lastname}}</td>
                      <td>{{user.usertype}}</td>
                      <td > <span *ngIf="user.usertype === 'Clientcomm'">{{user.idcomm}}</span> </td>
                      <td > <span *ngIf="user.usertype === 'Clientcomm'">{{user.raisonsociale}}</span> </td>
                      <td><button type="button" class="btn btn-black" (click)="getNavigationusers('auth/view-user',user._id)">Consulter</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Injection données porteurs" *ngIf="showcartewindow">
            <ng-template mat-tab-label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">Injection données porteurs</div>
                <span (click)="hidecarte()" class="ms-2"><i class="bi bi-x-circle-fill"></i></span>
              </div>
            </ng-template>
            <fieldset>
              <legend> Insérer fichier</legend>
              <div class="form-group row">
                <label class="col-sm-12 col-form-label"> Charger document</label>
                  <div class="col-sm-12">
                    <input type="file"  class="form-control inputFile" (change)="onFileChange6($event);">
                  </div>
              </div>
            </fieldset>
            <button class="btn btn-info" (click)="savedata()"*ngIf="exceljsondata6.length>0"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
          </mat-tab>
          <mat-tab label="Injection données commerçants" *ngIf="showcommwindow">
            <ng-template mat-tab-label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">Injection données commerçants</div>
                <span (click)="hidecomm()" class="ms-2"><i class="bi bi-x-circle-fill"></i></span>
              </div>
            </ng-template>
            <fieldset>
              <legend> Insérer fichier</legend>
              <div class="form-group row">
                <label class="col-sm-12 col-form-label"> Charger document</label>
                  <div class="col-sm-12">
                    <input type="file"  class="form-control inputFile" (change)="onFileChange7($event);">
                  </div>
              </div>
            </fieldset>
            <button class="btn btn-info" (click)="savedatacomm()"*ngIf="exceljsondata7.length>0"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
          </mat-tab>
          <mat-tab label="Injection plusieurs utilisateurs" *ngIf="showmultipleusersindow">
            <ng-template mat-tab-label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">Injection plusieurs utilisateurs</div>
                <span (click)="hidemultipleusers()" class="ms-2"><i class="bi bi-x-circle-fill"></i></span>
              </div>
            </ng-template>
            <fieldset>
              <legend> Insérer plusieurs utlisateurs   &nbsp;&nbsp;&nbsp; <a href="https://macompta.com.tn:3000/ptr/create-users.xlsx"target="_blank">Charger structure fichier</a> </legend>
              <div class="form-group row">
                <label class="col-sm-12 col-form-label"> Charger document</label>
                  <div class="col-sm-12">
                    <input type="file"  class="form-control inputFile" accept=".xls, .xlsx"(change)="onFileChange($event);">
                  </div>
              </div>
              <button class="btn btn-info" (click)="afficher()"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
            </fieldset>
          </mat-tab>
  </mat-tab-group>
</body>
